// extracted by mini-css-extract-plugin
module.exports = {"wrap":"_1TJD8","separate":"_1py-I","content":"T546j","yellow":"_300BS","text":"_28nHV"};